import { render, staticRenderFns } from "./AcademicRecordDisplay.vue?vue&type=template&id=7638da1d&scoped=true&"
import script from "./AcademicRecordDisplay.vue?vue&type=script&lang=js&"
export * from "./AcademicRecordDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AcademicRecordDisplay.vue?vue&type=style&index=0&id=7638da1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638da1d",
  null
  
)

export default component.exports